export enum RequestState {
	IDLE = "idle",
	REQUESTED = "requested",
	RECEIVED = "received",
	ERROR = "error",
}

export enum RoundStatus {
	SCHEDULED = "scheduled",
	PLAYING = "playing",
	COMPLETE = "complete",
}

export enum PositionType {
	CATCHER = "catcher",
	EMPTY = "",
	FIRST_BASE = "first_base",
	OUTFIELDER = "outfielder",
	PITCHER = "pitcher",
	SECOND_BASE = "second_base",
	SHORTSTOP = "shortstop",
	THIRD_BASE = "third_base",
}

export enum StatusType {
	ACTIVE = "active",
	INACTIVE = "inactive",
}

export enum PoolTabsType {
	POPULAR = "popular",
	SUGGESTED = "suggested",
	CLUB = "by_club",
	FAVORITE = "favorite",
	HOT_PICKS = "Hot Picks",
}

export enum LeaderboardsTabsType {
	YESTERDAY = "YESTERDAY",
	ACTIVE_STREAK = "ACTIVE_STREAK",
	ALL_SEASON = "SEASON_BEST_STREAK",
	ALL_TIME = "OVERALL_BEST_STREAK",
}

export enum LeaderboardUsersType {
	ALL = "ALL",
	FRIENDS = "FRIENDS",
}
export enum PredictionResult {
	HIT = "hit",
	NOT_HIT = "not_hit",
	VOID = "void",
	USED_MULLIGAN = "used_mulligan",
}

export enum UnitStatusType {
	SCHEDULED = "scheduled",
	PLAYING = "playing",
	COMPLETE = "complete",
	POSTPONED = "postponed",
	CANCELED = "canceled",
}

export enum TvNetwork {
	MLBTV = "MLBTV",
	YOU_TUBE = "YOUTUBE",
	FOX = "FOX",
	ESPN = "ESPN",
	TBS = "TBS",
	MLBN = "MLBN",
	ESPN2 = "ESPN2",
	FS1 = "FS1",
	APPLE_TV = "APPLE_TV",
}

export enum HelpPages {
	MULLIGAN = "mulligan",
	HOW_TO_PLAY = "tutorial",
	PRIZES = "prizes",
	TERMS = "terms",
}

export enum Handedness {
	LEFT = "left",
	RIGHT = "right",
	SWITCH = "switch",
}

export enum ProbabilityBench {
	SLEEPER = "sleeper",
}

export enum PlayerImageType {
	HEADSHOT = "headshot",
	ACTION_SHOT_IMAGE = "actionShotImage",
	ACTION_FULL_IMAGE = "actionFullImage",
}

export enum SocialNetwork {
	FACEBOOK,
	TWITTER,
	MOBILE,
}

export enum ShareType {
	LEAGUE = "league-invite",
}

export enum LeaguePrivacy {
	PRIVATE = "private",
	PUBLIC = "public",
}

export enum LeagueClass {
	FEATURED = "featured",
	REGULAR = "regular",
}

export enum UserLeaderboardClass {
	USUAL = "usual",
	FEATURED = "featured",
}

export enum ContextualProjects {
	BEAT_THE_STREAK = "beat_the_streak",
	BY_THE_NUMBER = "by_the_number",
	SPINBALL = "spinball",
	PLAYER_OF_THE_GAME = "player_of_the_game",
}


export enum BadgeType {
	STREAK_5 = "streak_5",
	STREAK_10 = "streak_10",
	STREAK_15 = "streak_15",
	STREAK_20 = "streak_20",
	STREAK_25 = "streak_25",
	STREAK_30 = "streak_30",
	STREAK_35 = "streak_35",
	STREAK_40 = "streak_40",
	STREAK_45 = "streak_45",
	STREAK_50 = "streak_50",
}